import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vuetify from 'vuetify'

import 'material-design-icons-iconfont/dist/material-design-icons.css'
import './assets/css/global.css' // Ensure you are using css-loader
import './assets/css/fontawesome/css/fontawesome.min.css'
import './assets/css/fontawesome/css/light.min.css'

import 'vuetify/dist/vuetify.min.css'
import colors from 'vuetify/es5/util/colors'

Vue.use(Vuetify, {
    theme: {
        primary: '#cb2390',
        secondary: colors.red.lighten4, // #FFCDD2
        accent: colors.indigo.base // #3F51B5
    },
    iconfont: 'md'
})

Vue.config.productionTip = false

const app = new Vue({
  router, store,
  render: h => h(App),
}).$mount('#app')

export { app, router, store}

